module.exports = __webpack_public_path__ + "img/27c9388a9fa699b678bd080bd8fa63ef.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/images/bulk.jpg
 ** module id = 423
 ** module chunks = 0
 **/